export const RESERVATION_ERROR_CODES = {
  INVALID_RESERVATION_ID: 'INVALID_RESERVATION_ID',
  MISSING_REQUIRED_FIELDS: 'MISSING_REQUIRED_FIELDS',
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
} as const

export const RESERVATION_ERROR_MESSAGES = {
  INVALID_RESERVATION_ID: 'Invalid reservation ID',
  MISSING_REQUIRED_FIELDS: 'Missing required fields',
  AUTH_REQUIRED_FOR_CREDIT: 'Authentication required for credit payment',
  INTERNAL_ERROR: 'Internal server error',
} as const

export const MODIFY_ERROR_CODES = {
  FAILED_TO_ALLOCATE_PAX_INVENTORY: 'FAILED_TO_ALLOCATE_PAX_INVENTORY',
  FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY: 'FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY',
  FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY_BY_WEIGHT: 'FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY_BY_WEIGHT',
  EXCLUDED_PRICE_CATEGORY: 'EXCLUDED_PRICE_CATEGORY',
  SAIL_NOT_FOUND: 'SAIL_NOT_FOUND',
  DISCOUNT_ALREADY_USED_ON_SAIL: 'DISCOUNT_ALREADY_USED_ON_SAIL',
  RESERVATION_REMOVED_ALL_ITEMS: 'RESERVATION_REMOVED_ALL_ITEMS',
  CURB_WEIGHT_VIOLATION: 'CURB_WEIGHT_VIOLATION',
  INVALID_PERSONAL_IDENTIFICATION_NUMBER: 'INVALID_PERSONAL_IDENTIFICATION_NUMBER',
} as const

export const VEHICLE_LOOKUP_ERROR_CODES = {
  VEHICLE_INFO_NOT_FOUND_IN_REGISTRY: 'VEHICLE_INFO_NOT_FOUND_IN_REGISTRY',
  VEHICLE_REGISTER_FAILURE: 'VEHICLE_REGISTER_FAILURE',
  INAPPROPRIATE_UI_FORM_USED: 'INAPPROPRIATE_UI_FORM_USED',
} as const
